import React, { memo } from 'react'
import PropTypes from 'prop-types'
import './Button.scss'
import { Link } from 'react-router-dom'
import Spinner from '../Spinner/Spinner'
import { SPINNER_TYPE } from '../Spinner/useSpinnerElement'

const Button = memo(
  ({
    children,
    theme = 'default',
    /**
      String: You can choose one of the following themes:
      - default (default)
      - white
      - bordered
      - dark
      - text
      - upload
      */
    size = 'regular',
    /**
      String: You can choose one of the following sizes:
      - regular (default)
      - small
      - normal
      - middle
      - middle-full
      - large-full
      */
    link,
    className = '',
    loading,
    ...rest
  }) => {
    const Tag = link ? Link : 'button'

    const tagProps = {
      className: `button button-${size} button-${theme} ${className}`,
      disabled: rest?.disabled || loading,
      ...rest,
    }

    if (Tag === 'button' && tagProps.type == null) {
      tagProps.type = 'button'
    }

    return (
      <Tag {...tagProps}>{loading ? <Spinner type={SPINNER_TYPE.SPINNER} size={20} strokeWith={3} /> : children}</Tag>
    )
  }
)

Button.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.string,
  size: PropTypes.string,
  link: PropTypes.bool,
  className: PropTypes.string,
}

export default Button
